<template>
  <v-container id="HomePage" fluid tag="section">
    <v-app-bar color="#b88611" dense dark>
      <v-toolbar-title>View the current stock</v-toolbar-title>

      <v-spacer />
    </v-app-bar>
    <div>
      <v-row>
        <v-col cols="12" md="12">
          <base-material-card color="#455A64" class="px-5 py-3" title="Here they are !!">
            <v-card-text class="px-0 pb-0">
              <v-sheet />

              <v-row>
                <v-col lg="12" sm="12" cols="12">
                  <v-card-title>
                    <v-spacer />
                    <v-text-field v-model="searchO" append-icon="mdi-magnify" label="Search" single-line hide-details
                      clearable dense outlined />
                  </v-card-title>
                  <v-data-table :headers="headers" :items="items" :search="searchO">
                    <template v-slot:item.deactivate="{ item }">
                      <v-btn v-if="isAdmin === true" color="green" @click="edit(item.id, item.quantity, item.inStock)">
                        Edit Qty
                      </v-btn>
                      <v-btn v-if="isAdmin === true" color="red" @click="deletee(item.id)">
                        Delete
                      </v-btn>
                    </template>
                  </v-data-table>
                  <!-- <table id="table_id" class="display">
                    <thead>
                      <tr>
                        <th>barcode</th>
                        <th>Name</th>
                        <th>Description</th>
                        <th>All Stock</th>
                        <th>In Stock</th>
                        <th v-if="isAdmin === true">Remove</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(i, index) in items" :key="index">
                        <td>{{ i.barcode }}</td>
                        <td>{{ i.name }}</td>
                        <td>{{ i.description }}</td>
                        <td>{{ i.quantity }}</td>
                        <td>{{ i.inStock }}</td>
                         <td><v-btn @click="email">bbbb</v-btn></td> 
                        <td v-if="isAdmin === true">
                          <v-btn
                            height="15"
                            color="amber"
                            @click="
                              edit(`${i.id}`, `${i.quantity}`, `${i.inStock}`)
                            "
                          >
                            Edit Stock
                          </v-btn>
                          <v-btn
                            height="15"
                            color="red"
                            @click="deletee(`${i.id}`)"
                          >
                            Delete
                          </v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </table> -->
                  <v-col lg="8" sm="8" cols="8">
                    <v-btn block color="green" @click="downloadExcel">
                      Download as a Excel
                    </v-btn>
                  </v-col>
                </v-col>
              </v-row>
            </v-card-text>
          </base-material-card>
        </v-col>
      </v-row>
    </div>
    <!-- Edit  ................................ Stock -->
    <v-row justify="center">
      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
          <v-card-title>
            <span class="headline">Edit Item Quantity</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field v-model="toUpdate" label="Stock" required type="number" />
                </v-col>
              </v-row>
            </v-container>
            to reduce quantity use ' - ' infornt of the number
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="blue darken-1" text @click="dialog = false">
              Close
            </v-btn>
            <v-btn color="blue darken-1" text @click="updateDB">
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- -----------------------Loader---------------------- -->
    <v-row>
      <v-dialog v-model="loader" persistent width="200">
        <v-card>
          <v-card-text>
            <v-container>
              <v-row class="justify-center">
                Please Wait...
              </v-row>
              <v-row class="mt-2 justify-center">
                <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import db from './api/firebaseInit';
// import firebase from 'firebase'
import Vue from 'vue';
import VueCookies from 'vue-cookies';
import VueSimpleAlert from 'vue-simple-alert';
import XLSX from 'xlsx';

Vue.use(VueSimpleAlert, VueCookies);

export default {
  data: function () {
    return {
      dataReady: false,
      items: [],
      dialog: false,
      toUpdate: null,
      toUpdateID: '',
      toUpdateInStock: '',
      toUpdateQuantity: '',
      isAdmin: 'false',
      loader: true,
      searchO: '',
      headers: [
        { text: 'Barcode', value: 'barcode' },
        { text: 'Name', value: 'name' },
        { text: 'Description', value: 'description' },
        { text: 'Total Stock', value: 'quantity' },
        { text: 'Current Stock', value: 'inStock' },
        { text: 'Admin Stuff', value: 'deactivate', align: 'center' },
      ],
    };
  },
  mounted() {
    if (VueCookies.isKey('maman')) {
      this.isAdmin = true;
    }
    // console.log(this.isAdmin);

    this.mountRun();
  },

  methods: {
    mountRun: function () {
      this.toUpdate = null;
      this.toUpdateID = '';
      this.toUpdateInStock = '';
      this.toUpdateQuantity = '';
      this.items = [];
      db.collection('items')
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            // // console.log(doc.data());
            var tempObj = {
              barcode: doc.data().barcode,
              name: doc.data().name,
              description: doc.data().description,
              quantity: doc.data().quantity,
              inStock: doc.data().inStock,
              id: doc.id,
            };
            this.items.push(tempObj);
          });
          this.loader = false;
        })
        .catch((err) => {
          const error = err;
          // console.log('Error getting documents', error)
        });
    },
    createArrayOfArrays({ headers = [], data = [] }) {
      let arrayOfArrays = [];
      arrayOfArrays.push(headers);

      data.map((rowObj) => {
        arrayOfArrays.push(Object.values(rowObj));
        return null;
      });
      return arrayOfArrays;
    },
    downloadExcel() {
      let ws_name = 'SheetJS';
      let wb = XLSX.utils.book_new();
      let d = new Date();
      let filename =
        'report_' +
        d
          .toISOString()
          .slice(0, 10)
          .replace(/-/g, '') +
        '.xlsx';
      let data = this.createArrayOfArrays({
        headers: [
          'Barcode',
          'Name',
          'Description',
          'Total Stock',
          'Current Stock',
        ],
        data: this.items.map((item) => {
          return {
            barcode: item.barcode,
            name: item.name,
            description: item.description,
            quantity: item.quantity,
            inStock: item.inStock,
          };
        }),
      });
      let ws = XLSX.utils.aoa_to_sheet(data);
      //   Add worksheet to workbook
      XLSX.utils.book_append_sheet(wb, ws, ws_name);
      XLSX.writeFile(wb, filename);
    },
    edit: function (e, f, g) {
      // console.log(f)
      this.toUpdate = null;
      this.toUpdateID = e;
      this.toUpdateQuantity = f;
      this.toUpdateInStock = g;
      this.dialog = true;
    },

    deletee: function (e) {
      // console.log(e)
      this.$confirm('You really want to delete?', '', 'warning').then(() => {
        this.loader = true;
        // console.log(e)
        db.collection('items')
          .doc(e)
          .delete()
          .then(() => {
            this.$alert('Item removal succesful', '', 'success');
            this.mountRun();
          });
      });
    },

    updateDB: function (e, f) {
      if (!isNaN(this.toUpdate)) {
        this.dialog = false;
        this.loader = true;
        // console.log(this.toUpdate)
        this.toUpdateInStock =
          Number(this.toUpdateInStock) + Number(this.toUpdate);
        this.toUpdateQuantity =
          Number(this.toUpdateQuantity) + Number(this.toUpdate);
        // toInStock
        db.collection('items')
          .doc(this.toUpdateID)
          .update({
            quantity: this.toUpdateQuantity,
            inStock: this.toUpdateInStock,
          })
          .then(() => {
            // alert('Done')
            this.$alert('Stock Updated :)', '', 'success');
            this.mountRun();
          });
      }

    },
  },
};
</script>
